var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-item-wrapper",
    {
      attrs: {
        designer: _vm.designer,
        field: _vm.field,
        rules: _vm.rules,
        "design-state": _vm.designState,
        "parent-widget": _vm.parentWidget,
        "parent-list": _vm.parentList,
        "index-of-parent-list": _vm.indexOfParentList,
        "sub-form-row-index": _vm.subFormRowIndex,
        "sub-form-col-index": _vm.subFormColIndex,
        "sub-form-row-id": _vm.subFormRowId,
      },
    },
    [
      !_vm.getReadMode()
        ? _c("ueditorFrom", {
            ref: "ueditorFrom",
            attrs: {
              height: "400px",
              type: "simple",
              content: _vm.fieldModel,
              disabled: _vm.field.options.disabled,
              placeholder: _vm.field.options.placeholder,
            },
            on: { input: _vm.ueditorEdit },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.getReadMode()
        ? [
            _c("div", {
              staticClass: "readonly-mode-field h-400",
              domProps: { innerHTML: _vm._s(_vm.contentForReadMode) },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }